'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageReadByVisitor = markMessageReadByVisitor;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIVECHAT_API_PREFIX = 'livechat/v1';

function markMessageReadByVisitor(_ref) {
  var threadId = _ref.threadId,
      sessionId = _ref.sessionId,
      message = _ref.message;

  var messageId = (0, _commonMessageFormatGetters.getMessageIdForCmf)(message);

  return _noAuthApiClient2.default.post(LIVECHAT_API_PREFIX + '/visitorReadThread/thread/' + threadId + '/message/' + messageId, {
    query: {
      portalId: _hubspot2.default.get(),
      sessionId: sessionId
    }
  });
}